import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getServiceType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: "/report/newPlan/findServiceTypeByStudentId",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getStudentInfoById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/getById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 艺考智能填报
  smartReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/smartReport/generationScheme`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 获取专业类别
  findSpecialityType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: "/art/smartReport/findSpecialityType",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 获取院校地域
  findAllProvince({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/smartReport/findAllProvince`).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 获取专业倾向
  findAllSpecialityCategoryAndSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/smartReport/findAllSpecialityCategoryAndSpeciality`, {
        params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 获取批次
  findAllBatchByProvinceId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/smartReport/findAllBatchByProvinceId`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  openNextStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/openNextStep`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getBindInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/bindCode/bindInfo`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  remind({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/remind`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  bind({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/bindCode/bind`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  checkStringCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/academicPlanning/checkStringCode",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  checkResult({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/academicPlanning/checkResult",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getOccupationList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/artOccupationEvaluation/answerList",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/selectSpecialityLibrary",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
      // axios.post(`/occupationEvaluation/selectSpecialityLibrary`, params).then(response => {
      //   resolve(response);
      // }).catch(error => {
      //   reject(error);
      // });
    });
  },
  findTeacherSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/occupationEvaluation/findTeacherSpeciality`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  insertSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/occupationEvaluation/insertSpecialityLibrary`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/findTeacherSpecialityOne",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getUserInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/getUserInfo`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  editReportState({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/academicPlanning/editReportState',
        params: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
};
